const base = {
    state: {
        siteConfig: {
            agencyId: -1
        },
        isLogin: false,
        loginUser: {},
    },
    mutations: {
        'SET_SITE_CONFIG': (state, config) => {
            state.siteConfig = config
        },
        'SET_USER_LOGIN': (state, loginInfo) => {
            if (loginInfo && Object.keys(loginInfo).length > 0) {
                state.isLogin = true;
                state.loginUser = loginInfo;
            } else {
                state.isLogin = false;
                state.loginUser = {};
            }
        }
    }
}

export default base